// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AuditLogController = function ($scope, auditLogService, PUtill, $routeParams, DatepickerUtils) {

    $scope.AuditLogCategories = {
        'All': PUtill.getText('All'),
        'ProductChanged': PUtill.getText('Product'),
        'SettingChanged': PUtill.getText('Setting'),
        'CustomerChanged': PUtill.getText('Customer'),
        'ContractChanged': PUtill.getText('Contract'),
        'EntityChanged': PUtill.getText('Entity')
    };

    $scope.category = '';
    $scope.categoryName = PUtill.getText('Classification');
    $scope.dateRange = { dateFrom: null, dateTo: null };

    let getParams = function () {
        let searchParams = {
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo),
            search: $scope.search
        };

        if ($scope.category)
            searchParams.category = $scope.category;

        return searchParams;
    };

    $scope.updateFilters = function () {
        var setDefaultDetails = function (result) {
            if (result && result.length > 0) {
                $scope.showDetails(result[0].Id);
            }
        };

        $scope.auditLogs = $scope.paginator(function (options, callback) {
            return auditLogService.query(options,
                function (result) {
                    callback();
                    setDefaultDetails(result);
                    $scope.wasSearching = options.search;
                });
        }, getParams(), 21);
    };

    $scope.showDetails = function (id) {
        $scope.loadingDetails = true;
        $scope.selectedAuditLog = auditLogService.get({ auditLogId: id }, function () {
            $scope.loadingDetails = false;
        });
    }

    $scope.setCategory = function (category, defaultLabelName) {
        $scope.category = category;
        $scope.categoryName = PUtill.getText(defaultLabelName || $scope.AuditLogCategories[category]);
        $scope.updateFilters();
    };

    function init() {
        $scope.search = '';
        $scope.wasSearching = false;
        $scope.selectedAuditLog = undefined;
        $scope.loadingDetails = false;

        if ($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }

        if (!$scope.search) {
            $scope.search ='';
        }

        $scope.updateFilters();
    }

    init();
};

AuditLogController.$inject = ['$scope', 'AuditLog', 'PUtill', '$routeParams', 'DatepickerUtils'];
